/* ============================================================
   Maison Atelier Premium — recently-viewed.js
   Salva e mostra gli ultimi prodotti visti (localStorage)
   ============================================================ */
(function () {
  'use strict';
  var settings = (window.theme && window.theme.settings) || {};
  var Wishlist = window.theme && window.theme.Wishlist;

  var RecentlyViewed = {
    key: 'sav_recently_viewed',
    limit: settings.recentlyViewedLimit || 8,
    get: function () {
      try { return JSON.parse(localStorage.getItem(this.key)) || []; } catch (e) { return []; }
    },
    record: function (handle) {
      if (!handle) return;
      var list = this.get().filter(function (h) { return h !== handle; });
      list.unshift(handle);
      list = list.slice(0, this.limit + 1);
      localStorage.setItem(this.key, JSON.stringify(list));
    }
  };
  window.theme = window.theme || {};
  window.theme.RecentlyViewed = RecentlyViewed;

  var pv = document.querySelector('[data-product-handle]');
  if (pv) RecentlyViewed.record(pv.getAttribute('data-product-handle'));

  var section = document.querySelector('[data-recently-viewed]');
  if (!section) return;

  var currentHandle = pv ? pv.getAttribute('data-product-handle') : null;
  var handles = RecentlyViewed.get().filter(function (h) { return h !== currentHandle; }).slice(0, RecentlyViewed.limit);
  if (!handles.length) return;

  var grid = section.querySelector('[data-recently-viewed-grid]');
  var pending = handles.length;
  handles.forEach(function (handle) {
    fetch('/products/' + handle + '?view=card')
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html.trim();
          var card = tmp.querySelector('[data-rv-card]') || tmp.firstElementChild;
          if (card && grid) grid.appendChild(card);
        }
      })
      .catch(function () {})
      .finally(function () {
        pending--;
        if (pending === 0 && grid && grid.children.length) {
          section.hidden = false;
          if (Wishlist) Wishlist.syncButtons(section);
          document.dispatchEvent(new CustomEvent('cards:rendered', { detail: { root: section } }));
        }
      });
  });
})();
